module.exports = __webpack_public_path__ + "static/horn-1cc939ed32236abbf1e9e4ccc504dfe0.mp3";